import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function _callSuper2(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

import { Component } from 'react';
import PropTypes from 'prop-types';
import ShopInterface from '../../api/ShopInterface';
import { ShopTabs } from './Constants';
import Screens from '../index';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants, { ShopTypes as paramShopTypes } from '../../utils/routeParamConstants';
import buyClickedHandler from './buyClickedHandler';
import Logger from '../../lib/analytics/logger';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import Utils from '../../utils';
import audio from '../../utils/audio';
import ENVIRONMENT_VARIABLES from '../../utils/environmentVariables';
import NotificationContext from '../../context/NotificationContext';
import { getText, TEXT_KEY } from '../../utils/localization';
import { getFullUnitName } from './utils';

var formatter = require('format-number');

var format = formatter({
  prefix: '',
  suffix: '',
  truncate: 0
});

var Shop = /*#__PURE__*/function (_Component) {
  function Shop(props) {
    var _this2;

    _classCallCheck(this, Shop);

    _this2 = _callSuper2(this, Shop, [props]);
    _this2._buyServerHandler = buyClickedHandler;
    _this2.checkBillingProfile = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var profiles;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return ShopInterface.getBillingProfiles();

            case 2:
              profiles = _context.sent;

              if (profiles.billingProfiles !== undefined) {
                _this2.props.setPurchaseProfile(profiles.billingProfiles);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    _this2._getPackages = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var paramShopType, shopTab, _this2$props, promoLink, setShopListCoins, isOutOfCoinsPurchase, isLTOPurchase, setShopListVip, currencyPackages, coinItems, vipItems, promoApplied, promoBoostDialogType, usedPromoBefore, i, saleEndDate, showPromoBoost, transformUnits, _i, _transformUnits, value, unitShort, unit;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              /**
               * @type {import("../../api/Constants").CurrencyPackagesResponse}
               */

              /** This bit automatically tabs over if the param is present. */
              paramShopType = QueryParamsProxy.findParam(RouteParamConstants.PARAM_SHOP_TYPE, paramShopTypes.COINS);
              _context2.t0 = paramShopType;
              _context2.next = _context2.t0 === paramShopTypes.COINS ? 5 : _context2.t0 === paramShopTypes.VIP ? 7 : 9;
              break;

            case 5:
              shopTab = ShopTabs.COINS;
              return _context2.abrupt("break", 10);

            case 7:
              shopTab = ShopTabs.VIP;
              return _context2.abrupt("break", 10);

            case 9:
              console.error('Invalid ShopType.');

            case 10:
              _this2$props = _this2.props, promoLink = _this2$props.promoLink, setShopListCoins = _this2$props.setShopListCoins, isOutOfCoinsPurchase = _this2$props.isOutOfCoinsPurchase, isLTOPurchase = _this2$props.isLTOPurchase, setShopListVip = _this2$props.setShopListVip;

              if (!promoLink.code) {
                _context2.next = 17;
                break;
              }

              _context2.next = 14;
              return ShopInterface.getCurrencyPackages(promoLink.code);

            case 14:
              currencyPackages = _context2.sent;
              _context2.next = 20;
              break;

            case 17:
              _context2.next = 19;
              return ShopInterface.getCurrencyPackages();

            case 19:
              currencyPackages = _context2.sent;

            case 20:
              currencyPackages.PAYMENT_PROVIDER !== _this2.props.paymentProvider && _this2.props.setPaymentProvider(currencyPackages.PAYMENT_PROVIDER);
              coinItems = currencyPackages.PACKAGE_LIST.coins.items;
              vipItems = currencyPackages.PACKAGE_LIST.vip_room_access.items;
              promoApplied = currencyPackages.PACKAGE_LIST.coins.promo_applied;
              _this2.promoApplied = promoApplied === 'yes' ? true : false;
              promoBoostDialogType = null;
              usedPromoBefore = false;
              if (promoLink.code) _this2.props.lastPromoCode === promoLink.code ? usedPromoBefore = true : _this2.props.setLastPromoCode(promoLink.code);

              if (promoApplied === 'yes' && !promoLink.active) {
                !usedPromoBefore ? promoBoostDialogType = 'success' : promoBoostDialogType = 'error';
              } else if (promoApplied === 'no') {
                promoBoostDialogType = 'error';
              }

              for (i = 0; i < coinItems.length; i++) {
                coinItems[i].AMOUNT = format(coinItems[i].AMOUNT);
                coinItems[i].ALT_AMOUNT = format(coinItems[i].ALT_AMOUNT);
                coinItems[i].ORIGINAL_AMOUNT = format(coinItems[i].ORIGINAL_AMOUNT);
                coinItems[i].BONUS_LOYALTY_AMOUNT = format(coinItems[i].BONUS_LOYALTY_AMOUNT);
                coinItems[i].PROMO_BOOSTED_VALUE = format(coinItems[i].PROMO_BOOSTED_VALUE);
                coinItems[i].AMOUNT_INCLUDING_SALE_AND_PROMO = format(coinItems[i].AMOUNT_INCLUDING_SALE_AND_PROMO);
                coinItems[i].PROMO_BOOST_PERCENTAGE = format(currencyPackages.PACKAGE_LIST.coins.promo_percentage);
                coinItems[i].SALE_PERCENTAGE = format(currencyPackages.PACKAGE_LIST.coins.sale_percentage);
              }

              saleEndDate = new Date();
              saleEndDate.setSeconds(saleEndDate.getSeconds() + currencyPackages.PACKAGE_LIST.coins.time_left || 0);
              showPromoBoost = promoApplied === 'yes' && promoLink.active;
              setShopListCoins(coinItems);
              isOutOfCoinsPurchase(false); // Making out-of-coins purchase to false

              isLTOPurchase(false);

              transformUnits = function transformUnits(value, unitName) {
                var units = [{
                  name: 'Sec',
                  divisorToNext: 60
                }, {
                  name: 'Min',
                  divisorToNext: 60
                }, {
                  name: 'Hr',
                  divisorToNext: 24
                }, {
                  name: 'Day'
                }];
                var unitIndex = units.findIndex(function (unit) {
                  return unit.name === unitName;
                }); // if we've already hit the max, return

                if (units[unitIndex].divisorToNext === undefined) {
                  return {
                    value: value,
                    unit: unitName
                  };
                }

                var newValue = value / units[unitIndex].divisorToNext; // if the new value goes below 1, we've divided too far, return

                if (newValue < 1) {
                  return {
                    value: value,
                    unit: unitName
                  };
                }

                return transformUnits(newValue, units[unitIndex + 1].name);
              };

              for (_i = 0; _i < vipItems.length; _i++) {
                _transformUnits = transformUnits(vipItems[_i].duration_in_seconds, 'Sec'), value = _transformUnits.value, unitShort = _transformUnits.unit;
                unit = getFullUnitName(unitShort, value);
                vipItems[_i].duration_friendly = "".concat(value, " ").concat(unitShort);
                vipItems[_i].duration_friendly_full = "".concat(value, " ").concat(unit);
              }

              _this2.setState({
                vipItems: vipItems,
                shopTab: shopTab,
                coinItems: currencyPackages.PACKAGE_LIST.coins.items,
                saleEndDate: saleEndDate,
                isSaleOn: currencyPackages.PACKAGE_LIST.coins.sale,
                coinBackground: currencyPackages.PACKAGE_LIST.coins.sale_background_image,
                promoBoostDialogMessage: currencyPackages.PACKAGE_LIST.coins.message,
                promoBoostPercentage: currencyPackages.PACKAGE_LIST.coins.promo_percentage,
                promoBoostDialogType: promoBoostDialogType,
                showPromoBoost: showPromoBoost
              }, function () {
                return _this2.checkToRedeemPromoLink();
              });

              setShopListVip(vipItems);
              _context2.next = 45;
              break;

            case 42:
              _context2.prev = 42;
              _context2.t1 = _context2["catch"](0);
              console.log(_context2.t1);

            case 45:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 42]]);
    }));

    _this2._setShopTabHandler = function (newTab) {
      audio.onClick();
      var dismissModal = _this2.props.dismissModal;

      switch (newTab) {
        case ShopTabs.BACK:
          {
            dismissModal();
            break;
          }

        case ShopTabs.COINS:
          {
            QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_SHOP_TYPE, paramShopTypes.COINS));
            break;
          }

        case ShopTabs.VIP:
          {
            QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_SHOP_TYPE, paramShopTypes.VIP));
            break;
          }

        default:
          console.error('Invalid tab');
      }

      _this2.setState({
        shopTab: newTab
      });
    };

    _this2._buyClickedHandler = function (sku, name, type, amount, trigger) {
      audio.onClick();
      Logger.setActionTrigger(trigger);
      var _this2$props2 = _this2.props,
          assignTransationUUID = _this2$props2.assignTransationUUID,
          coins = _this2$props2.coins;

      _this2._buyServerHandler(sku, name);

      var platform = Utils.getPlatform();
      var store;

      switch (platform) {
        case 'web':
          store = 'cams';
          break;

        case 'ios':
          store = 'appstore';
          break;

        default:
          store = platform;
      }

      var id = Logger.generateUUID();
      assignTransationUUID(id);
      var eventPayload = {
        type: type === 'vip_room_access' ? 'vip' : 'regular',
        product_id: sku,
        currency: 'usd',
        store: store,
        balance_before: coins,
        is_test: ENVIRONMENT_VARIABLES.ENVIRONMENT !== 'PROD' ? 1 : 0,
        amount: amount,
        id: id,
        trigger: trigger
      };
      Logger.sendEvent(EVENT_TYPES.TRANSACTION_INITIATED, eventPayload);
    };

    _this2._freeConsumableClickedHandler = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(itemId, itemType) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                audio.onClick();

                _this2._freeConsumableServerHandler(itemId, itemType);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x, _x2) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this2._freeConsumableServerHandler = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(itemId, itemType) {
        var setPurchaseType, success;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                setPurchaseType = _this2.props.setPurchaseType;
                _context4.next = 4;
                return ShopInterface.claimFreeConsumable(itemId, itemType);

              case 4:
                success = _context4.sent;

                if (success) {
                  setPurchaseType(itemType);
                  QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.PurchaseSucceeded));
                } else {
                  _this2.context.addNotification({
                    message: getText(TEXT_KEY.CONSUMABLE_CLAIM_FAILED_ALERT),
                    title: getText(TEXT_KEY.GENERIC_MESSAGE_ERROR),
                    button: getText(TEXT_KEY.OK)
                  });
                }

                ShopInterface.refreshActiveConsumables();
                _context4.next = 12;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](0);
                console.error(_context4.t0);

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 9]]);
      }));

      return function (_x3, _x4) {
        return _ref4.apply(this, arguments);
      };
    }();

    _this2._promoBoostDialogButtonHandler = function () {
      audio.onClick();

      _this2.setState({
        promoBoostDialogType: null
      });
    };

    _this2.checkToRedeemPromoLink = function () {
      var promoLink = _this2.props.promoLink;

      if (promoLink && promoLink.code) {
        Logger.sendEvent(EVENT_TYPES.PROMOLINK_CLICKED, {
          code: promoLink.code
        });
      }

      var _this2$state = _this2.state,
          promoBoostDialogType = _this2$state.promoBoostDialogType,
          promoBoostDialogMessage = _this2$state.promoBoostDialogMessage,
          coinItems = _this2$state.coinItems;
      var _this2$props3 = _this2.props,
          activatePromocode = _this2$props3.activatePromocode,
          setShopListCoins = _this2$props3.setShopListCoins,
          dismissInvalidPromocode = _this2$props3.dismissInvalidPromocode;

      if (promoBoostDialogType !== null && !!promoBoostDialogMessage) {
        if (promoBoostDialogType === 'success' || _this2.promoApplied) {
          _this2.setState({
            showPromoBoost: true
          }, function () {
            activatePromocode();
            setShopListCoins(coinItems);
          });
        } else {
          dismissInvalidPromocode();
        }
      }
    };

    _this2._hasVIPPass = function () {
      var unlimitedVipAccess = _this2.props.unlimitedVipAccess;

      if (unlimitedVipAccess) {
        _this2.props.dismissModal();

        QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.VipAccessFlow));
      }
    };

    _this2.state = {
      /** @type {import('../../api/Constants').CurrencyPackageItemKeys[]} */
      coinItems: [],
      vipItems: [],
      shopTab: undefined,
      // Externally loaded, if available. Null otherwise.
      coinBackground: null
    };
    _this2.promoApplied = false;
    return _this2;
  }

  _inherits(Shop, _Component);

  return _createClass(Shop, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var isOffer, offerDetail;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this._getPackages();

                this.checkBillingProfile();
                ShopInterface.refreshActiveConsumables();
                this._buyServerHandler = buyClickedHandler.bind(this);
                isOffer = QueryParamsProxy.findParam(RouteParamConstants.PARAM_OFFER_ENABLE, null);

                if (isOffer) {
                  offerDetail = QueryParamsProxy.findParam(RouteParamConstants.PARAM_OFFER_DETAIL, null);

                  this._buyServerHandler(offerDetail.sku, offerDetail.name, offerDetail.type, offerDetail.amount);
                }

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _QueryParamsProxy$set5;

      QueryParamsProxy.setQueryParams((_QueryParamsProxy$set5 = {}, _defineProperty(_QueryParamsProxy$set5, RouteParamConstants.PARAM_SHOP_TYPE, undefined), _defineProperty(_QueryParamsProxy$set5, RouteParamConstants.PARAM_OFFER_ENABLE, undefined), _QueryParamsProxy$set5));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          render = _this$props.render,
          assetsUrls = _this$props.assetsUrls,
          unlimitedVipAccess = _this$props.unlimitedVipAccess;
      var _this$state = this.state,
          shopTab = _this$state.shopTab,
          newsItems = _this$state.newsItems,
          coinItems = _this$state.coinItems,
          vipItems = _this$state.vipItems,
          isSaleOn = _this$state.isSaleOn,
          showPromoBoost = _this$state.showPromoBoost,
          promoBoostDialogType = _this$state.promoBoostDialogType,
          promoBoostDialogMessage = _this$state.promoBoostDialogMessage,
          promoBoostPercentage = _this$state.promoBoostPercentage,
          coinBackground = _this$state.coinBackground,
          saleEndDate = _this$state.saleEndDate;
      return render( // Pass state and handlers to platform renderer
      {
        assetsUrls: assetsUrls,
        shopTab: shopTab,
        setShopTabHandler: this._setShopTabHandler,
        newsItems: newsItems,
        coinItems: coinItems,
        vipItems: vipItems,
        buyHandle: this._buyClickedHandler,
        freeHandle: this._freeConsumableClickedHandler,
        unlimitedVipAccess: unlimitedVipAccess,
        isSaleOn: isSaleOn,
        showPromoBoost: showPromoBoost,
        promoBoostDialogType: promoBoostDialogType,
        promoBoostDialogMessage: promoBoostDialogMessage,
        promoBoostPercentage: promoBoostPercentage,
        promoBoostDialogButtonHandle: this._promoBoostDialogButtonHandler,
        hasVIPPass: this._hasVIPPass,
        // External assets to load
        coinSale: {
          backgroundImage: coinBackground,
          endDate: saleEndDate
        }
      });
    }
  }]);
}(Component);

Shop.contextType = NotificationContext;
export { Shop as default };
Shop.propTypes = {
  promoLink: PropTypes.object,
  setShopListCoins: PropTypes.func.isRequired,
  isOutOfCoinsPurchase: PropTypes.func.isRequired,
  isLTOPurchase: PropTypes.func.isRequired,
  setShopListVip: PropTypes.func.isRequired,
  dismissModal: PropTypes.func.isRequired,
  setPurchaseType: PropTypes.func.isRequired,
  activatePromocode: PropTypes.func.isRequired,
  dismissInvalidPromocode: PropTypes.func.isRequired,
  render: PropTypes.func.isRequired,
  assignTransationUUID: PropTypes.any.isRequired,
  coins: PropTypes.any.isRequired
};
Shop.defaultProps = {
  promoLink: {}
};